import { useEffect } from "react";
import { useParams } from "react-router-dom";

import { CompendiumEntries } from "../components/CompendiumEntries";
import { KeyItemEntries } from "../components/KeyItemEntries";
import { SeriesShelf } from "../components/SeriesShelf";
import { booksInSeries, pageTitle, SERIES } from "../config/site";
import { NotFoundPage } from "./NotFoundPage";

export function SeriesPage() {
  const { seriesSlug } = useParams();
  const series = SERIES.find((item) => item.slug === seriesSlug);

  useEffect(() => {
    if (series !== undefined) {
      document.title = pageTitle(series.title);
    }
  }, [series]);

  if (series === undefined) {
    return <NotFoundPage />;
  }
  return (
    <div className="landing">
      <h1 className="landing-title">{series.title}</h1>
      <SeriesShelf series={series} heading={false} />
      <CompendiumEntries books={booksInSeries(series.id)} />
      <KeyItemEntries books={booksInSeries(series.id)} />
    </div>
  );
}
